var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InterfaceEdit',{ref:"InterfaceEdit",attrs:{"languageOne":_vm.languageOne,"languageTwo":_vm.languageTwo,"languageThree":_vm.languageThree,"languageFour":_vm.languageFour}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }